import request from '../request';

let storedLocations = { locations: [] };
if (localStorage.getItem('locations') !== null) {
  storedLocations = JSON.parse(localStorage.getItem('locations'));
}

export default {
  state: {
    data: storedLocations,
    typesById: [],
    districtTypeId: undefined,
    municipalityTypeId: undefined,
    riverTypeId: undefined,
    mountainTypeId: undefined,
    nationalParkTypeId: undefined,
    naturalParkTypeId: undefined,
    nationalForestTypeId: undefined,
    nuts2Locations: [],
    nuts2ById: {},
    districts: [],
    districtsById: {},
    municipalities: [],
    municipalitiesByDistrictId: {},
    mountainsByNuts2: {},
    riversByNuts2: {},
    // nationalParkByNuts2: {},
    // naturalParkByNuts2: {},
    protectedAreasByNuts2: {},
    placesByNuts2: {},
  },
  mutations: {
    setLocations(state, payload) {
      Object.assign(state, { data: payload });

      const typesById = {};
      let nuts2TypeId;
      let districtTypeId;
      let municipalityTypeId;
      let riverTypeId;
      let mountainTypeId;
      let protectedAreaTypeId;
      let placeTypeId;


      payload.types.forEach((type) => {
        Object.assign(typesById, { [type.id]: type.name });
        switch (type.name) {
          case 'Nuts 2':
            nuts2TypeId = type.id;
            break;
          case 'District':
            districtTypeId = type.id;
            break;
          case 'Municipality':
            municipalityTypeId = type.id;
            break;
          case 'River':
            riverTypeId = type.id;
            break;
          case 'Mountain':
            mountainTypeId = type.id;
            break;
          case 'Protected Area':
            protectedAreaTypeId = type.id;
            break;
          case 'Place':
            placeTypeId = type.id;
            break;
          default:
            break;
        }
      });
      // Sort Locations
      payload.locations.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });


      const nuts2Locations = [];
      const nuts2ById = {};

      const districts = [];
      const districtsById = {};

      const municipalities = [];
      const municipalitiesByDistrictId = {};

      const mountainsByNuts2 = {};
      const riversByNuts2 = {};
      const protectedAreasByNuts2 = {};
      const placesByNuts2 = {};


      payload.locations.forEach((location) => {
        switch (location.location_type_id) {
          case nuts2TypeId:
            nuts2Locations.push(location);
            nuts2ById[location.id] = location.name;
            break;
          case districtTypeId:
            districts.push(location);
            districtsById[location.id] = location.name;
            break;
          case municipalityTypeId:
            municipalities.push(location);
            if (typeof municipalitiesByDistrictId[location.parent_id] === 'undefined') {
              municipalitiesByDistrictId[location.parent_id] = [];
            }
            municipalitiesByDistrictId[location.parent_id].push(
            { id: location.id, name: location.name, nuts2Id: location.nuts2_id },
            );
            break;
          case mountainTypeId:
            if (typeof mountainsByNuts2[location.nuts2_id] === 'undefined') {
              mountainsByNuts2[location.nuts2_id] = [];
            }
            mountainsByNuts2[location.nuts2_id].push(
            { id: location.id, name: location.name },
            );
            break;
          case riverTypeId:
            if (typeof riversByNuts2[location.nuts2_id] === 'undefined') {
              riversByNuts2[location.nuts2_id] = [];
            }
            riversByNuts2[location.nuts2_id].push(
            { id: location.id, name: location.name },
            );
            break;
          case protectedAreaTypeId:
            if (typeof protectedAreasByNuts2[location.nuts2_id] === 'undefined') {
              protectedAreasByNuts2[location.nuts2_id] = [];
            }
            protectedAreasByNuts2[location.nuts2_id].push({
              id: location.id,
              name: location.name,
              prefix1: location.prefix_1,
              prefix2: location.prefix_2,
            });
            break;
          case placeTypeId:
            if (typeof placesByNuts2[location.nuts2_id] === 'undefined') {
              placesByNuts2[location.nuts2_id] = [];
            }
            placesByNuts2[location.nuts2_id].push(
            { id: location.id, name: location.name },
            );
            break;
          default:
            break;
        }
      });

      Object.assign(state, {
        typesById,
        districtTypeId,
        municipalityTypeId,
        riverTypeId,
        mountainTypeId,
        protectedAreaTypeId,
        nuts2Locations,
        nuts2ById,
        districts,
        districtsById,
        municipalities,
        municipalitiesByDistrictId,
        mountainsByNuts2,
        riversByNuts2,
        protectedAreasByNuts2,
        placesByNuts2,
      });
    },
  },
  actions: {
    getLocations(context) {
      request.make({
        type: 'GET',
        url: `${process.env.API_URL}location`,
      }, (err, res) => {
        if (res.status === 200) {
          context.commit('setLocations', res.body.data);
          if (context.rootState.search.location.label === null) {
            const searchLocation = context.rootState.search.location;
            if (searchLocation.label === null) {
              context.dispatch('search/setLocation', searchLocation, { root: true });
            }
          }
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/locations.js